'use strict';

function isUndefined(o) {
  return o === undefined;
}

module.exports = isUndefined;